import { create } from "zustand";
import { AiccPromptGroup } from "constants/aiccPrompt";

export interface SandboxSavedPrompt {
  languageId: number;
  promptKey: string;
  name: string;
  group?: AiccPromptGroup;
  savedAt: number;
}

interface SandboxSavesState {
  lastSaved?: SandboxSavedPrompt;
  announceSave: (saved: Omit<SandboxSavedPrompt, "savedAt">) => void;
}

export const useSandboxSavesStore = create<SandboxSavesState>()((set) => ({
  lastSaved: undefined,
  announceSave: (saved) => set({ lastSaved: { ...saved, savedAt: Date.now() } }),
}));
